/**
 * Timestamp normalizasyon fonksiyonu
 * Farklı formatlardaki timestamp değerlerini ISO string formatına dönüştürür
 */
export const normalizeTimestamp = (value) => {
  if (!value) {
    return new Date().toISOString();
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (typeof value === 'number') {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return date.toISOString();
    }
    return new Date().toISOString();
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return new Date().toISOString();
    }

    if (/^\d+$/.test(trimmed)) {
      const numericValue = Number(trimmed);
      if (Number.isFinite(numericValue)) {
        const date = new Date(numericValue);
        if (!Number.isNaN(date.getTime())) {
          return date.toISOString();
        }
      }
    }

    const date = new Date(trimmed);
    if (!Number.isNaN(date.getTime())) {
      return date.toISOString();
    }

    return new Date().toISOString();
  }

  return new Date().toISOString();
};

